module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-08.13606380.jpg";